module.exports = __webpack_public_path__ + "static/media/1.e3953af8.png";